module.exports = __webpack_public_path__ + "img/wt3.af3de2da.png";